import React from 'react';
import cx from 'classnames';

import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';
import TabsList from '../TabsList';

import styles from './CoursesHeader.module.scss';
import usePresenter from './CoursesHeader.presenter';
import getProps from './CoursesHeader.props';
import { CoursesHeaderCombinedProps } from './types';


const CoursesHeader: React.FC<CoursesHeaderCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    tabsList,
    divider,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.coursesHeader;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.content, classes?.content)}>
        <div className={cx(styles.topContent, classes?.topContent)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
        <TabsList
          className={cx(styles.tabsList, classes?.tabsList)}
          {...internalProps.tabsList}
          {...tabsList}/>
      </div>
      <Divider
        className={cx(styles.divider, classes?.divider)}
        {...internalProps.divider}
        {...divider}/>
    </div>
  );
};

export default CoursesHeader;

